import { useSelector, useDispatch } from 'react-redux'
import PlayerActions from 'reducers/Player'
import { trackEvent } from 'utils/segmentService'
import { normalizeValue } from 'utils/analytics'

const useAutoPlayToggle = () => {
  const dispatch = useDispatch()
  const autoPlay = useSelector((state) => state.player.autoPlay)
  const selectedSong = useSelector((state) => state.player.song)
  const hasNoSong = !selectedSong || Object.keys(selectedSong).length === 0

  const handleToggleAutoPlay = (event) => {
    event?.stopPropagation?.()

    if (hasNoSong) return

    const nextAutoPlay = !autoPlay
    dispatch(PlayerActions.toggleAutoPlay(nextAutoPlay))
    trackEvent('Playback Autoplay Toggle', {
      autoplay: normalizeValue(nextAutoPlay),
      source: 'player',
      type: 'playback_settings'
    })
  }

  return {
    autoPlay,
    hasNoSong,
    handleToggleAutoPlay
  }
}

export default useAutoPlayToggle
